import BackButton from "./back-button.component.js";

export default angular
    .module("oui.back-button", [])
    .component("ouiBackButton", BackButton)
    .name;
